import axios from "axios";
import { ensureCsrfToken } from "../../../../lib/csrf";

const BASE = "/api/digital-risk/portfolio-optimization-evidence/";

export async function acceptPortfolioOptimizationEvidence(optimizerResponse) {
  const csrf = await ensureCsrfToken();
  return (await axios.post(`${BASE}accept/`, { optimizerResponse }, {
    withCredentials: true,
    headers: { "X-CSRFToken": csrf },
  })).data;
}

export async function fetchCurrentPortfolioOptimizationEvidence() {
  try {
    return (await axios.get(`${BASE}current/`, { withCredentials: true })).data;
  } catch (error) {
    if (error?.response?.status === 404) return null;
    throw error;
  }
}

export async function fetchPortfolioOptimizationEvidence(reference) {
  return (await axios.get(`${BASE}${reference}/`, { withCredentials: true })).data;
}
